import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import { createRoot } from 'react-dom/client';

import { App } from './app';

if (import.meta.env.DEV && import.meta.env.VITE_MSW === 'on') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./mocks/browser');
  worker.start();
}

/**
 * Hide error overlay in test environment
 */
const hideErrorOverlayInTestEnv = `#vite-error-overlay {display:${
  import.meta.env.VITE_DEPLOYMENT_PHASE?.includes('test') ? 'none' : 'unset'
};}`;
const style = document.createElement('style');
document.head.appendChild(style);
style.innerHTML = hideErrorOverlayInTestEnv;

TimeAgo.addDefaultLocale(en);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.querySelector('#app')!);

root.render(<App />);
